import PropTypes from 'prop-types';
import React, { Component } from 'react';

class Audio extends Component {
  constructor(props) {
    super(props);
    this.audio = null;
    this.logger = (msg) => {
      if (this.props.logger) {
        console.info(`Audio: ${msg}`);
      }
    };
  }

  componentDidMount() {
    /* Looping Logic */
    this.audio.addEventListener('ended', () => {
      this.processEnded();
    });
    this.logger('Playing Audio...');
    this.audio.load();
    this.audio.play();
  }

  /* Prevent unnecessary renders */
  shouldComponentUpdate(nextProps) {
    return nextProps.pause !== this.props.pause;
  }

  /*  */
  componentWillUpdate(nextProps) {
    if (nextProps.pause) {
      this.logger('Pausing Audio...');
      this.audio.pause();
    } else {
      this.logger('Playing Audio...');
      this.audio.load();
      this.audio.play();
    }
  }

  componentWillUnmount() {
    this.audio.removeEventListener('ended', () => {
      this.processEnded();
    });
  }

  processEnded() {
    this.logger('Audio ended...');
    if (!this.props.pause && this.props.loop) {
      this.logger('Audio Looped, Playing...');
      this.audio.currentTime = 0;
      this.audio.play();
    }
  }

  render() {
    return (
      <audio
        ref={(audio) => {
          this.audio = audio;
        }}
      >
        <source src={this.props.source} type={this.props.type} preload="auto" />
      </audio>
    );
  }
}

Audio.propTypes = {
  logger: PropTypes.bool.isRequired,
  loop: PropTypes.bool.isRequired,
  pause: PropTypes.bool,
  source: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

Audio.defaultProps = {
  logger: false,
  loop: false,
};

export default Audio;



// WEBPACK FOOTER //
// ./src/components/Audio.js